export default __webpack_public_path__ + "images/fd00e5509c8da7ed8e58b6fa81129485-language.jpg";